export const isTargetInsidePickerElements = (
  target: EventTarget | null,
  resolvedInputElement: HTMLInputElement | null,
  popoverElement: HTMLDivElement | null
): boolean => {
  if (!target) return false;

  const node = target as Node;

  if (node.isSameNode(resolvedInputElement) && popoverElement === null) {
    return false;
  }

  return (
    (resolvedInputElement?.contains(node) ?? false) ||
    (popoverElement?.contains(node) ?? false) ||
    (node.isSameNode(resolvedInputElement) && popoverElement === null)
  );
};
